'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM4 12h4v2H4v-2zm10 6H4v-2h10v2zm6 0h-4v-2h4v2zm0-4H10v-2h10v2z' });

var Subtitles = function Subtitles(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

Subtitles = (0, _pure2.default)(Subtitles);
Subtitles.muiName = 'SvgIcon';

exports.default = Subtitles;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/Subtitles.js
// module id = 2906
// module chunks = 0